/**
 * Created by alex.y on 7/31/2017.
 */
export class SearchResponse<T> {
    public Items: Array<T>;
    public TotalCount: number;

    public constructor(obj?: Partial<SearchResponse<T>>){
        Object.assign(this, obj)
    }
}


// WEBPACK FOOTER //
// ./app/objects/responses/searchResponse.ts